import React, { useContext } from "react";
import { Backdrop, Box, Typography, makeStyles } from "@material-ui/core";
import LoadingContext from "./LoadingContext";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 9999,
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  spinnerRing: {
    position: "absolute",
    width: "120px",
    height: "120px",
    border: "4px solid rgba(200, 12, 15, 0.2)",
    borderTop: "4px solid #c80c0f",
    borderRadius: "50%",
    animation: "$rotateClockwise 2s linear infinite",
  },
  logoWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    zIndex: 1,
    animation: "$scaleAndRotate 3s ease-in-out infinite",
  },
  logo: {
    width: "70px",
    height: "70px",
  },
  message: {
    color: "#ffffff",
    fontSize: "18px",
    fontWeight: 500,
    textAlign: "center",
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
    marginTop: theme.spacing(8),
  },
  "@keyframes rotateClockwise": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
  "@keyframes scaleAndRotate": {
    "0%, 100%": {
      transform: "scale(1) rotate(0deg)",
    },
    "50%": {
      transform: "scale(1.3) rotate(-180deg)",
    },
  },
}));

const LoadingOverlay: React.FC = () => {
  const classes = useStyles();
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error("LoadingOverlay must be used within LoadingProvider");
  }

  const { isLoading, message } = context;

  return (
    <Backdrop className={classes.backdrop} open={isLoading}>
      <Box className={classes.logoContainer}>
        {/* Spinning Ring */}
        <Box className={classes.spinnerRing} />

        {/* Logo with Scale and Counter-Rotate */}
        <Box className={classes.logoWrapper}>
          <img src="thy.png" alt="Loading..." className={classes.logo} />
        </Box>
        {/* Message */}
        {message && <Typography className={classes.message}>{message}</Typography>}
      </Box>
    </Backdrop>
  );
};

export default LoadingOverlay;
